import React, { useState } from "react";

interface CollapsiblePanelProps {
  title: React.ReactNode;
  defaultExpanded?: boolean;
  children: React.ReactNode;
  onToggle?: (expanded: boolean) => void;
  isExpanded?: boolean;
  headerActions?: React.ReactNode;
  showApplyButton?: boolean;
  onApplyToggle?: () => void;
  isApplied?: boolean;
}

export const CollapsiblePanel: React.FC<CollapsiblePanelProps> = ({
  title,
  defaultExpanded = true,
  children,
  onToggle,
  isExpanded,
  headerActions,
  showApplyButton = false,
  onApplyToggle,
  isApplied = false,
}) => {
  const [internalExpanded, setInternalExpanded] = useState(defaultExpanded);

  const expanded = isExpanded !== undefined ? isExpanded : internalExpanded;

  const toggle = () => {
    const next = !expanded;
    if (isExpanded === undefined) {
      setInternalExpanded(next);
    }
    if (onToggle) onToggle(next);
  };

  return (
    <div className="border-b border-gray-200 dark:border-gray-700">
      <button
        onClick={toggle}
        className="w-full px-4 py-3 text-left bg-gray-50 dark:bg-gray-800 hover:bg-gray-100 dark:hover:bg-gray-700 border-b border-gray-200 dark:border-gray-600 font-medium text-gray-900 dark:text-white flex items-center justify-between"
      >
        <div className="flex items-center gap-3 min-w-0">
          <div className="flex-1 min-w-0 truncate">{title}</div>
          {showApplyButton && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                if (onApplyToggle) onApplyToggle();
              }}
              className={`px-3 py-1 text-xs rounded w-50 ${
                isApplied
                  ? "bg-green-500 text-white"
                  : "bg-blue-500 text-white hover:bg-blue-600"
              }`}
            >
              {isApplied ? "Applied" : "Apply"}
            </button>
          )}
          {headerActions && (
            <div className="border-gray-200 dark:border-gray-600 bg-gray-50 dark:bg-gray-800 flex items-center">
              {headerActions}
            </div>
          )}
        </div>
        <span
          className={`transform transition-transform ${
            expanded ? "rotate-90" : "rotate-0"
          }`}
        >
          ▶
        </span>
      </button>

      {expanded && <div className="p-0">{children}</div>}
    </div>
  );
};
